import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { InvoiceBadge, formatDate } from '../components/shared';

const STATUSES = ['', 'issued', 'sent', 'paid'];

export default function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [status, setStatus] = useState('');
  const navigate = useNavigate();

  const load = useCallback(() => {
    const params = {};
    if (status) params.status = status;
    api.getInvoices(params).then(setInvoices).catch(() => {});
  }, [status]);

  useEffect(() => { load(); }, [load]);

  const total = invoices.reduce((s, i) => s + (i.amount || 0), 0);

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">INVOICES <span>_</span></h1>
        {total > 0 && (
          <div>
            <span className="text-dim text-sm mono">Total: </span>
            <span className="mono fw-600 text-green">{total.toLocaleString()} EGP</span>
          </div>
        )}
      </div>

      <div className="table-wrap">
        <div className="table-toolbar filter-bar">
          {STATUSES.map(s => (
            <button key={s} className={`btn btn-sm ${status === s ? 'btn-primary' : 'btn-ghost'}`} onClick={() => setStatus(s)}>
              {s === '' ? 'All' : s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>
        <table>
          <thead>
            <tr>
              <th>Invoice #</th>
              <th>Device</th>
              <th>Serial</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Issued</th>
              <th>Sent</th>
              <th>Paid</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {invoices.length === 0 ? (
              <tr><td colSpan={9}><div className="empty">No invoices found</div></td></tr>
            ) : invoices.map(inv => (
              <tr key={inv.id}>
                <td className="mono text-sm fw-500">{inv.invoice_number || '—'}</td>
                <td className="fw-500">{inv.device_name}{inv.client_name && <div className="text-xs text-dim">{inv.client_name}</div>}</td>
                <td><span className="mono text-sm">{inv.device_serial}</span></td>
                <td><span className="mono text-sm">{inv.amount ? `${inv.amount.toLocaleString()} EGP` : '—'}</span></td>
                <td><InvoiceBadge status={inv.status} /></td>
                <td className="mono text-sm text-dim">{formatDate(inv.issued_at)}</td>
                <td className="mono text-sm text-dim">{formatDate(inv.sent_at)}</td>
                <td className="mono text-sm text-dim">{formatDate(inv.paid_at)}</td>
                <td>
                  {inv.ticket_id
                    ? <button className="btn btn-ghost btn-sm" onClick={() => navigate(`/tickets/${inv.ticket_id}`)}>View Ticket</button>
                    : inv.visit_id && <button className="btn btn-ghost btn-sm" onClick={() => navigate(`/maintenance/visit/${inv.visit_id}`)}>View Visit</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
